import { ListItemText } from '@mui/material';
import cn from 'classnames';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { NavRootMenuItem } from './styles';

type Props = {
  onClick: () => void;
  selected?: boolean;
  isTreeview?: boolean;
};

export const MoreNavItensButton = ({
  onClick,
  selected,
  isTreeview,
}: Props) => {
  const { translate } = useLocales();
  return (
    <NavRootMenuItem
      onClick={onClick}
      selected={selected}
      className={cn({ isTreeview })}
    >
      <Iconify icon="tabler:dots" color="text.secondary" />
      <ListItemText secondary={translate('header.nav.more')} />
    </NavRootMenuItem>
  );
};
